/* GeoDomeX sale events (GB and US). The calendars, event prices and wording live in snippets/gdxs-sale-config.liquid
   (window.GDXS_SALE). Every other market gets window.GDXS_SALE_LITE instead (24 Oct 2026, owner: "keep card trust symbols
   for USA / EU etc same as UK"): the order summary's free express delivery row, the payment icons and the add-on tick
   boxes, with no banner, no calendar and the free LED Lighting Kit with every dome as before.
   - Banner in the configurator purchase box (and the dome product page): live event name and a countdown to the
     event's fixed end, the same for everyone: UK time for GB, US Eastern time for the US (tz in the config).
     The countdown is always hours, minutes and seconds, e.g. 60h 12m 05s (24 Oct 2026, owner).
   - US (24 Oct 2026, owner: "follow UK structure more closely, like keeping sale urgency timer, USA relevant names"):
     the UK structure (banner, countdown, free LED kit only while an event runs) with its own American event names.
   - The banner shows for every dome while an event runs (23 Oct 2026, owner); in the V1.3 order summary it sits under
     the heading and the build line, above the rows.
   - Dome lines listed in evp (Original Mini and Standard, every Large) get an Offer line property in the basket, shown
     in the basket and at checkout; Ultra and Extreme Mini and Standard never get it.
     The property is hidden from the page's own basket reads so configurator basket checks still match.
   - Nothing shows when no event is running; a dome above its event price gets no Offer line.
   - Order summary: shows the free express delivery row with the add-ons and payment icons under the trust row
     (every market; the row's words are translated by the storefront translator, e.g. Express shipping in the US).
   - Add-ons step: a tick box to the left of each add-on card's Details text, as on the live V2.1 configurator.
     No base has no Details (24 Oct 2026, owner): its card keeps only the tick box, and a tap there selects No base.
   - Free LED Lighting Kit (23 Oct 2026, owner): part of each event. With no event running the page gets the class
     gdxs-no-sale, which hides everything marked .gdxs-led (store pages, configurators, basket, the homepage's own
     sections), the same second the banner goes; the kit is then not added to the basket, and kits already there come
     out on the next page view. The store pages and configurators read the same calendar (gdxs-core.js G.ledOn).
   - Preview only (unpublished theme): ?gdx_sale_at=2026-10-31T12:00:00Z simulates that moment. */
(function () {
  'use strict';
  var C = window.GDXS_SALE, LITE = !C && !!window.GDXS_SALE_LITE;
  if ((!C && !LITE) || window.__gdxsSale) return;
  window.__gdxsSale = 1;
  if (LITE) C = {};
  var KEY = C.key || 'Offer', T = C.t || {}, D = C.domes || {}, EVP = C.evp || {}, TZ = C.tz || 'Europe/London';

  var skew = 0;
  try {
    var q = new URLSearchParams(location.search).get('gdx_sale_at');
    if (q && window.Shopify && Shopify.theme && Shopify.theme.role !== 'main') {
      var qt = Date.parse(q);
      if (!isNaN(qt)) skew = qt - Date.now();
    }
  } catch (e) {}
  function now() { return Date.now() + skew; }

  /* minutes the calendar's time zone is ahead of UTC at instant ms (London: 0 in winter, 60 in summer; New York: -300 or -240) */
  function off(ms) {
    try {
      var o = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: TZ, hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })
        .formatToParts(new Date(ms)).forEach(function (p) { o[p.type] = p.value; });
      return Math.round((Date.UTC(+o.year, +o.month - 1, +o.day, +o.hour % 24, +o.minute) - ms) / 60000);
    } catch (e) { return 0; }
  }
  function ukDay(s, add) { var a = s.split('-'), g = Date.UTC(+a[0], +a[1] - 1, +a[2] + (add || 0)); return g - off(g) * 60000; }
  var EV = (C.events || []).map(function (e) { return { n: e[0], s: ukDay(e[1]), e: ukDay(e[1], e[2]) }; });
  function current() { var t = now(); for (var i = 0; i < EV.length; i++) if (t >= EV[i].s && t < EV[i].e) return EV[i]; return null; }

  var money = (function () {
    try {
      /* 3 Nov 2026 (owner): no thousands separators in prices (£1500, not £1,500) */
      var f = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: false });
      return function (p) { return f.format(p / 100); };
    } catch (e) { return function (p) { return '£' + Math.round(p / 100); }; }
  })();
  /* a dome is on sale when it is listed in evp and sits at (or below) its event price; save = RRP - price */
  function onSale(id, price) {
    var d = id != null && D[id];
    if (!d) return null;
    var p = price == null ? d[0] : price, ev = EVP[d[2]];
    if (ev == null || p > ev) return null;
    return { save: d[1] > p ? d[1] - p : 0 };
  }
  function fill(s, ev, save) { return String(s || '').replace('{name}', ev.n).replace('{save}', money(save)); }
  function propFor(id, ev, price) {
    if (!ev) return '';
    var o = onSale(id, price);
    return o ? fill(o.save ? T.prop : T.prop0, ev, o.save) : '';
  }

  /* ---------- banner ----------
     23 Oct 2026, checked against Apple's design principles (owner): text at 13 px in sentence case with no letter-spacing
     (the old 10.5 px capitals were below Apple's 11 pt minimum), a tinted surface that defers to the green checkout
     button, the countdown as the one solid accent, a 40 px bar with 12 px corners like the delivery panel, spacing on the
     4/8 px grid and equal space above and below it in the order summary. Contrast 7.3:1 and 8.2:1 (AAA). The time left
     is always hours, minutes and seconds, e.g. 60h 12m 05s (24 Oct 2026, owner); a long name shortens with an ellipsis
     before the countdown does. */
  var CSS = [
    '.gdxs-sale{--gs-ac:#9B1B1F;--gs-bg:#FBF0EF;box-sizing:border-box;display:flex;flex-wrap:nowrap;align-items:center;justify-content:space-between;gap:10px;width:100%;min-height:40px;margin:0 0 16px;padding:6px 6px 6px 14px;border-radius:12px;background:var(--gs-bg);color:var(--gs-ac);font-family:inherit;text-align:left}',
    '.gdxs-sale *{box-sizing:border-box}',
    '.gdxs-sale p{margin:0;color:inherit}',
    '.gdxs-sale__t{display:flex;flex:1 1 auto;min-width:0;align-items:center;gap:8px;font-size:13px;font-weight:600;letter-spacing:0;line-height:1.2;text-transform:none;white-space:nowrap}',
    '.gdxs-sale__n{min-width:0;overflow:hidden;text-overflow:ellipsis}',
    '.gdxs-sale__dot{position:relative;flex:0 0 auto;width:7px;height:7px;border-radius:50%;background:var(--gs-ac)}',
    '.gdxs-sale__dot::after{content:"";position:absolute;inset:0;border-radius:50%;background:var(--gs-ac);animation:gdxs-pulse 2s ease-out infinite}',
    '@keyframes gdxs-pulse{0%{transform:scale(1);opacity:.45}80%,100%{transform:scale(2.6);opacity:0}}',
    '.gdxs-sale__pill{flex:0 0 auto;display:inline-flex;align-items:center;height:28px;padding:0 10px;border-radius:999px;background:var(--gs-ac);color:#fff;font-size:13px;font-weight:600;line-height:1;letter-spacing:.01em;white-space:nowrap;font-variant-numeric:tabular-nums}',
    /* V1.3 order summary: the label below has its own space above its text, so the bar needs none below it */
    '#section-review .gdxs-sale{margin-bottom:0}',
    '@media (max-width:380px){.gdxs-sale{gap:8px;padding:6px 5px 6px 12px}.gdxs-sale__t{font-size:12px}.gdxs-sale__dot{display:none}.gdxs-sale__pill{height:26px;padding:0 8px;font-size:12px}}',
    /* 1 Nov 2026 (prelaunch check, 60 screen sizes): 22-character names fit on one line on every phone from 360 px wide;
       at 390-402 px (iPhone 12 to 17) and 360 px they were cut short by 1-16 px */
    '@media (min-width:381px) and (max-width:440px){.gdxs-sale{gap:8px}.gdxs-sale__t{font-size:12px}.gdxs-sale__pill{padding:0 8px;font-size:12px}}',
    '@media (max-width:380px){.gdxs-sale{gap:6px;padding:6px 5px 6px 10px}.gdxs-sale__t{font-size:11.5px}.gdxs-sale__pill{padding:0 7px;font-size:11.5px}}',
    '@media (max-width:340px){.gdxs-sale__t,.gdxs-sale__pill{font-size:11px}}',
    '@media (prefers-reduced-motion:reduce){.gdxs-sale__dot::after{animation:none;opacity:0}}'
  ].join('');
  var cfgVid = null;
  window.addEventListener('geodomex:variant-selected', function (e) { cfgVid = e && e.detail ? e.detail.variantId : null; tick(); });
  function firstDome(str) {
    var m = String(str || '').match(/[0-9]{8,}/g) || [];
    for (var i = 0; i < m.length; i++) if (D[m[i]]) return m[i];
    return null;
  }
  /* order summary label such as Standard 3.5m · Ultra -> the geodomex-1 variant for that size and spec */
  function byLabel(t) {
    var w = String(t || '').toLowerCase().split(/[^a-z0-9.]+/);
    function has(x) { return w.indexOf(x) > -1; }
    var size = has('mini') ? 'mini' : has('standard') ? 'standard' : has('large') ? 'large' : '';
    if (!size) return null;
    var key = size + '-' + (has('extreme') ? 'extreme' : has('ultra') ? 'ultra' : 'original');
    for (var id in D) if (D[id][2] === key) return id;
    return null;
  }
  var SLOTS = [
    { q: '#section-review .section-content', at: 'in', v: function () { var s = document.getElementById('review-selection'); return s ? byLabel(s.textContent) : null; } },
    { q: '#gdx-step-4 .gdx-checkout', at: 'in', v: function () { return cfgVid; } },
    { q: '.gdx-purchase-body .gdx-checkout', at: 'in', v: function () { var a = document.getElementById('configuration-buy'); return a ? firstDome(a.getAttribute('href')) : null; } },
    { q: '.price-row', at: 'before', need: '[data-gdxs-gp]', v: function (h) { var f = h.closest('form, section, main') || document, s = f.querySelector('[name=id]'); return s ? s.value : null; } }
  ];
  function ensureCss() {
    if (document.getElementById('gdxs-sale-css')) return;
    var s = document.createElement('style'); s.id = 'gdxs-sale-css'; s.textContent = CSS; document.head.appendChild(s);
  }
  function make() {
    var b = document.createElement('div');
    b.className = 'gdxs-sale';
    /* one bar on one line: sale name on the left, countdown on the right (names are kept to 22 characters) */
    b.innerHTML = '<p class=gdxs-sale__t><span class=gdxs-sale__dot aria-hidden=true></span><span class=gdxs-sale__n></span></p>' +
      '<span class=gdxs-sale__pill role=timer data-gdxs-notr><span data-k=tm></span></span>';
    b.querySelector('[role=timer]').setAttribute('aria-label', T.ends || 'Ends in');
    return b;
  }
  function z(n) { return (n < 10 ? '0' : '') + n; }
  function set(b, sel, txt) { var n = b.querySelector(sel); if (n && n.textContent !== txt) n.textContent = txt; }
  /* always hours, minutes and seconds: 60h 12m 05s (24 Oct 2026, owner) */
  function paint(b, ev) {
    var s = Math.max(0, Math.floor((ev.e - now()) / 1000));
    set(b, '.gdxs-sale__n', ev.n);
    set(b, '[data-k=tm]', Math.floor(s / 3600) + 'h ' + z(Math.floor(s % 3600 / 60)) + 'm ' + z(s % 60) + 's');
  }
  function tick() {
    if (LITE) return;
    var ev = current();
    led(!ev);
    SLOTS.forEach(function (sl) {
      Array.prototype.forEach.call(document.querySelectorAll(sl.q), function (h) {
        if (sl.need && !h.querySelector(sl.need)) return;
        var prev = h.previousElementSibling;
        var b = sl.at === 'in' ? h.querySelector(':scope > .gdxs-sale') : (prev && prev.classList.contains('gdxs-sale') ? prev : null);
        if (!b && h.offsetParent === null) return;
        var vid = null;
        try { vid = sl.v(h); } catch (e) {}
        /* every dome while an event runs (23 Oct 2026, owner: the countdown stays on whatever is chosen) */
        var o = ev && vid && D[vid] ? (onSale(vid) || { save: 0 }) : null;
        if (!o) { if (b) b.remove(); return; }
        if (!b) {
          ensureCss(); b = make();
          if (sl.at === 'in') h.insertBefore(b, h.firstChild); else h.parentNode.insertBefore(b, h);
        }
        paint(b, ev);
      });
    });
  }

  /* ---------- free LED Lighting Kit: only while an event runs (23 Oct 2026, owner) ----------
     .gdxs-led is hidden whenever no event runs; .gdxs-led-alt (a stand-in that keeps a grid whole) shows only then.
     The theme's own sections that promise the kit are marked here: the sticky bar line, the homepage confidence panel,
     the older dome pages' offer list and trust grid, and the announcement bar. */
  var LED = [].concat(C.led || []).map(String);
  var LCSS = 'html.gdxs-no-sale .gdxs-led{display:none!important}html:not(.gdxs-no-sale) .gdxs-led-alt{display:none!important}';
  var AR = '<path d="M4 8V5a1 1 0 0 1 1-1h3M16 4h3a1 1 0 0 1 1 1v3M20 16v3a1 1 0 0 1-1 1h-3M8 20H5a1 1 0 0 1-1-1v-3"/><path d="M12 7l4 2.3v4.6L12 16l-4-2.1V9.3z"/>';
  function isLed(id) { return LED.indexOf(String(id)) > -1; }
  function led(off) {
    if (!document.getElementById('gdxs-led-css')) { var st = document.createElement('style'); st.id = 'gdxs-led-css'; st.textContent = LCSS; document.head.appendChild(st); }
    document.documentElement.classList.toggle('gdxs-no-sale', off);
    markLed();
  }
  /* a stand-in grid item: same markup, another true benefit (3D and AR are on the homepage and the dome pages) */
  function altItem(el) {
    var a = el.cloneNode(true), h = a.querySelector('h1,h2,h3,h4,h5,strong,b'), p = a.querySelector('p'), svg = a.querySelector('svg');
    a.classList.remove('gdxs-led'); a.classList.add('gdxs-led-alt'); a.removeAttribute('id');
    if (h) h.textContent = 'Try It in Your Garden First';
    if (p) p.textContent = 'Place your GeoDomeX in your own garden with 3D and AR on your phone before you buy.';
    if (svg) { svg.setAttribute('viewBox', '0 0 24 24'); svg.innerHTML = AR; }
    el.parentNode.insertBefore(a, el.nextSibling);
  }
  function wrapText(el, res) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      for (var i = 0; i < res.length; i++) {
        var m = res[i].exec(n.nodeValue);
        if (!m) continue;
        var mid = n.splitText(m.index); mid.splitText(m[0].length);
        var sp = document.createElement('span'); sp.className = 'gdxs-led';
        mid.parentNode.insertBefore(sp, mid); sp.appendChild(mid);
        return;
      }
    }
  }
  function markLed() {
    Array.prototype.forEach.call(document.querySelectorAll('.sticky-product-sub, .gdx-confidence__item, .geo-trust-item, .gdx-pdp-offer li, .custom-announcement-text'), function (el) {
      if (el.__gdxsLed || !/\bLED\b/.test(el.textContent)) return;
      el.__gdxsLed = 1;
      if (el.classList.contains('custom-announcement-text')) { wrapText(el, [/\s*[|·•]\s*Free LED Lighting Kit/i, /Free LED Lighting Kit\s*[|·•]?\s*/i]); return; }
      el.classList.add('gdxs-led');
      if (el.classList.contains('sticky-product-sub')) {
        var a = el.cloneNode(false); a.removeAttribute('id'); a.classList.remove('gdxs-led'); a.classList.add('gdxs-led-alt'); a.textContent = 'Free express delivery included';
        el.parentNode.insertBefore(a, el.nextSibling);
      } else if (!el.matches('.gdx-pdp-offer li')) altItem(el);
    });
  }

  /* ---------- order summary ----------
     The configurator builds an Express delivery / Free row but hides it (V1.3 class gdx13-delivery-row and the
     garden rule on data-item-kind=shipping). Rebuild it like the LED kit row, with the truck icon, under Add-ons;
     drop the duplicate free-delivery heading above the button (the estimate stays); add the payment icons under
     the trust row, as on the live V2.1 configurator. */
  var SCSS = '#section-review.gdxs-ship .purchase-delivery-heading{display:none!important}' +
    '.gdxs-pay{display:flex;flex-wrap:wrap;justify-content:center;gap:6px;margin:14px 0 0}' +
    '.gdxs-pay svg{width:38px;height:24px}';
  function summary() {
    if (!document.getElementById('gdxs-sum-css')) { var st = document.createElement('style'); st.id = 'gdxs-sum-css'; st.textContent = SCSS; document.head.appendChild(st); }
    var items = document.getElementById('configuration-items'), sec = document.getElementById('section-review');
    if (items) {
      var sh = items.querySelector('[data-item-kind=shipping], [data-item-kind=gdxs-ship]');
      if (sh) { sh.classList.remove('gdx13-delivery-row'); shipRow(sh); }
      if (sec) sec.classList.toggle('gdxs-ship', !!sh);
      /* runs after the configurator's own summary tidy, before the next paint */
      if (!items.__gdxs && window.MutationObserver) { items.__gdxs = new MutationObserver(function () { Promise.resolve().then(summary); }); items.__gdxs.observe(items, { childList: true, subtree: true }); }
    }
    var rr = document.getElementById('review-reassurance'), tpl = document.getElementById('gdxs-pay-tpl');
    if (rr && tpl && tpl.content && !rr.querySelector('.gdxs-pay')) {
      var d = document.createElement('div'); d.className = 'gdxs-pay'; d.appendChild(tpl.content.cloneNode(true)); rr.appendChild(d);
    }
  }

  function svgEl(paths) {
    var ns = 'http://www.w3.org/2000/svg', s = document.createElementNS(ns, 'svg');
    s.setAttribute('viewBox', '0 0 24 24'); s.setAttribute('fill', 'none'); s.setAttribute('stroke', 'currentColor'); s.setAttribute('stroke-width', '1.5'); s.setAttribute('aria-hidden', 'true');
    paths.forEach(function (x) { var e = document.createElementNS(ns, x[0]); for (var k in x[1]) e.setAttribute(k, x[1][k]); s.appendChild(e); });
    return s;
  }
  function shipRow(sh) {
    if (sh.getAttribute('data-item-kind') === 'gdxs-ship') return;
    sh.setAttribute('data-item-kind', 'gdxs-ship');
    sh.classList.add('purchase-bonus-item', 'gdxs-ship-item');
    var copy = document.createElement('span'), txt = document.createElement('span'), t = document.createElement('strong'), sm = document.createElement('small'), badge = document.createElement('strong');
    copy.className = 'purchase-bonus-copy'; badge.className = 'purchase-bonus-badge';
    t.textContent = 'Express delivery'; sm.textContent = 'Tracked to your door'; badge.textContent = 'FREE';
    txt.appendChild(t); txt.appendChild(sm);
    copy.appendChild(svgEl([['path', { d: 'M2 5h13v12H2zM15 9h4l3 4v4h-7' }], ['circle', { cx: '6', cy: '18', r: '2' }], ['circle', { cx: '18', cy: '18', r: '2' }]]));
    copy.appendChild(txt);
    sh.replaceChildren(copy, badge);
  }

  /* ---------- add-on checkboxes ----------
     The live V2.1 tick box, placed to the left of each add-on card's Details text (on the assembly card, its
     Check postcode / Add to order text). Ticking it selects or removes the add-on; Details still opens. */
  var ACSS = '.gdxs-check{flex:0 0 auto;display:inline-flex;align-items:center;justify-content:center;width:22px;height:22px;margin:0;border:2px solid #d1d5db;border-radius:4px;background:#fff;box-sizing:border-box;cursor:pointer;transition:background .15s,border-color .15s}' +
    '.gdxs-check svg{width:12px;height:12px;opacity:0;transition:opacity .15s}' +
    '.gdxs-check.is-on{background:#166534;border-color:#166534}' +
    '.gdxs-check.is-on svg{opacity:1}' +
    /* 22 Oct 2026: the box sits at the left edge of the card's footer, with its own tap area (widened invisibly to about
       38 px). The Details text sits in the middle of the space right of the box, with the same gap on each side (owner) */
    '.gdxs-foot{position:relative!important}' +
    '.gdxs-foot>.gdxs-check{position:absolute;left:10px;top:50%;margin-top:-11px}' +
    '.gdxs-foot>.gdxs-check::after{content:"";position:absolute;inset:-10px -8px}' +
    '.gdx-base-details-trigger.gdxs-foot{justify-content:center!important;padding-left:42px!important;padding-right:10px!important}' +
    '.gdx-assembly-card-action.gdxs-foot{justify-content:center!important;text-align:center!important;padding-left:36px!important;padding-right:4px!important}' +
    '.gdx-assembly-card-action.gdxs-foot::after{display:none!important}' +
    '#dome-explorer #base-options .gdx-option-check,#gdx-shade-selected .gdx-shade-card-check{display:none!important}' +
    /* No base: the footer keeps only its tick box (no Details text or arrow) */
    '.gdx-base-details-trigger.gdxs-nb{font-size:0!important;cursor:pointer}' +
    '.gdx-base-details-trigger.gdxs-nb::after{display:none!important}' +
    /* no rule above the rating under the purchase box */
    '#dome-explorer .gdx-purchase-trust{border-top:0!important}';
  function tickBox() {
    var ns = 'http://www.w3.org/2000/svg', w = document.createElement('span'), s = document.createElementNS(ns, 'svg'), p = document.createElementNS(ns, 'path');
    w.className = 'gdxs-check'; w.setAttribute('aria-hidden', 'true');
    s.setAttribute('viewBox', '0 0 12 12'); s.setAttribute('fill', 'none');
    p.setAttribute('d', 'M2 6l3 3 5-5'); p.setAttribute('stroke', '#fff'); p.setAttribute('stroke-width', '2'); p.setAttribute('stroke-linecap', 'round'); p.setAttribute('stroke-linejoin', 'round');
    s.appendChild(p); w.appendChild(s);
    return w;
  }
  /* host: where the box goes (before its text); on(): is the add-on selected; pick: the button that selects it */
  function placeCheck(host, on, pick) {
    if (!host) return;
    var b = host.querySelector(':scope > .gdxs-check');
    if (!b) {
      b = tickBox(); host.insertBefore(b, host.firstChild); host.classList.add('gdxs-foot');
      if (pick) b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); pick.click(); setTimeout(refreshChecks, 60); });
    }
    b.__on = on;
  }
  function refreshChecks() {
    Array.prototype.forEach.call(document.querySelectorAll('.gdxs-check'), function (b) { if (b.__on) b.classList.toggle('is-on', !!b.__on()); });
  }
  /* No base needs no Details (24 Oct 2026, owner): its Details button (which opens the photo sheet) is swapped for a
     plain footer that keeps the tick box; a tap anywhere on it selects No base. The card's own button stays the one
     control for screen readers and keyboards. */
  function noBase(c, btn) {
    var trg = c.querySelector('.gdx-base-details-trigger');
    if (!trg || trg.classList.contains('gdxs-nb')) return trg;
    var f = document.createElement('div');
    f.className = 'gdx-base-details-trigger gdxs-nb';
    f.setAttribute('aria-hidden', 'true');
    f.addEventListener('click', function () { btn.click(); setTimeout(refreshChecks, 60); });
    trg.parentNode.replaceChild(f, trg);
    return f;
  }
  /* the configurator's Details text is a button (class gdx-base-details-trigger) that opens the photo sheet:
     on each base card, and on the sunshade card (id shade-photo-details) */
  function addonChecks() {
    var base = document.querySelectorAll('#base-options .gdx-base-choice'), shade = document.getElementById('shade-photo-details'), asm = document.querySelector('.gdx-assembly-option');
    if (!base.length && !shade && !asm) return;
    if (!document.getElementById('gdxs-add-css')) { var st = document.createElement('style'); st.id = 'gdxs-add-css'; st.textContent = ACSS; document.head.appendChild(st); }
    Array.prototype.forEach.call(base, function (c) {
      var btn = c.querySelector('[data-base]');
      if (!btn) return;
      var host = btn.getAttribute('data-base') === 'none' ? noBase(c, btn) : c.querySelector('.gdx-base-details-trigger');
      placeCheck(host, function () { return btn.getAttribute('aria-pressed') === 'true'; }, btn);
    });
    var sel = document.getElementById('gdx-shade-selected');
    if (shade && sel) placeCheck(shade, function () { return sel.getAttribute('aria-pressed') === 'true'; }, sel);
    if (asm) placeCheck(asm.querySelector('.gdx-assembly-card-action'), function () { return asm.classList.contains('is-selected'); }, null);
    refreshChecks();
    /* base options are rebuilt when the size or spec changes: put the boxes back before the next paint */
    var bo = document.getElementById('base-options');
    if (bo && !bo.__gdxs && window.MutationObserver) { bo.__gdxs = new MutationObserver(function () { Promise.resolve().then(addonChecks); }); bo.__gdxs.observe(bo, { childList: true, subtree: true }); }
  }
  document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('#dome-explorer')) setTimeout(refreshChecks, 60); }, true);

  /* ---------- basket Offer line property ---------- */
  var of = window.fetch;
  function path(u) { return String(u || '').split('?')[0]; }
  function ends(p, list) { return list.some(function (x) { return p.slice(-x.length) === x; }); }
  function isAdd(u) { return ends(path(u), ['/cart/add', '/cart/add.js']); }
  function isRead(u) { return ends(path(u), ['/cart.js', '/cart/add.js', '/cart/change.js', '/cart/update.js']); }
  function urlOf(i) { return typeof i === 'string' ? i : (i && i.url) || String(i || ''); }
  function tag(item, ev) {
    var p = propFor(item.id, ev);
    if (!p) return false;
    var pr = {}, src = item.properties || {};
    for (var k in src) if (Object.prototype.hasOwnProperty.call(src, k)) pr[k] = src[k];
    pr[KEY] = p; item.properties = pr;
    return true;
  }
  function clean(res) {
    try {
      if (!res || !res.ok) return res;
      /* Shopify serves /cart.js as text/javascript, so parse the text rather than trusting the content type */
      return res.clone().text().then(function (txt) {
        var j, hit = false;
        try { j = JSON.parse(txt); } catch (e) { return res; }
        function c(it) { if (it && it.properties && Object.prototype.hasOwnProperty.call(it.properties, KEY)) { delete it.properties[KEY]; hit = true; } }
        if (j && Array.isArray(j.items)) j.items.forEach(c); else c(j);
        return hit ? new Response(JSON.stringify(j), { status: res.status, statusText: res.statusText, headers: res.headers }) : res;
      }, function () { return res; });
    } catch (e) { return res; }
  }
  if (!LITE && typeof of === 'function') {
    window.fetch = function (input, init) {
      var url = urlOf(input);
      try {
        if (isAdd(url) && init && typeof init.body === 'string' && init.body.charAt(0) === '{') {
          var ev = current(), b = JSON.parse(init.body), hit = false;
          /* no event running: the free LED kit is not added (from any page or older script) */
          if (!ev && LED.length) {
            if (Array.isArray(b.items)) { var keep = b.items.filter(function (it) { return !isLed(it.id); }); if (keep.length !== b.items.length) { b.items = keep; hit = true; } }
            if ((Array.isArray(b.items) && !b.items.length) || (b.id && isLed(b.id))) return Promise.resolve(new Response('{"items":[]}', { status: 200, headers: { 'Content-Type': 'application/json' } }));
          }
          if (ev) {
            if (Array.isArray(b.items)) b.items.forEach(function (it) { if (tag(it, ev)) hit = true; });
            else if (b.id && tag(b, ev)) hit = true;
          }
          if (hit) init = Object.assign({}, init, { body: JSON.stringify(b) });
        }
      } catch (e) {}
      var r = of.call(window, input, init);
      return isRead(url) ? r.then(clean) : r;
    };
  }
  /* keep the property true: an event that has ended (or changed) is rewritten or removed on the next page view */
  function sync() {
    if (LITE || !C.cart || typeof of !== 'function') return;
    of.call(window, '/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var ev = current(), jobs = [];
        (c.items || []).forEach(function (it, i) {
          /* the event has ended: free LED kits added during it come out */
          if (!ev && isLed(it.variant_id) && !(it.final_price > 0)) { jobs.push({ line: i + 1, quantity: 0 }); return; }
          var want = propFor(it.variant_id, ev, it.original_price || it.price), have = (it.properties && it.properties[KEY]) || '';
          if (want === have) return;
          var pr = {};
          for (var k in (it.properties || {})) if (k !== KEY) pr[k] = it.properties[k];
          if (want) pr[KEY] = want;
          jobs.push({ line: i + 1, quantity: it.quantity, properties: pr });
        });
        if (!jobs.length) return;
        return jobs.reverse().reduce(function (p, j) {
          return p.then(function () { return of.call(window, '/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(j) }); });
        }, Promise.resolve()).then(function () {
          var S = window.GDXS;
          if (S && S.cart && S.cart.fetch) S.cart.fetch().then(function (c2) { if (S.emit) S.emit('cart', c2); }, function () {});
          if (!ends(location.pathname, ['/cart', '/cart/'])) return;
          try { var last = +sessionStorage.getItem('gdxsSaleSync') || 0; if (Date.now() - last < 60000) return; sessionStorage.setItem('gdxsSaleSync', String(Date.now())); } catch (e) { return; }
          location.reload();
        });
      })
      .catch(function () {});
  }

  function start() { tick(); summary(); addonChecks(); setInterval(function () { tick(); summary(); addonChecks(); }, 1000); sync(); }
  /* (tick and sync do nothing in the lite markets: no banner, no calendar, the LED kit untouched) */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
